import GuideSearch from './GuideSearch';
import styles from './GuideHero.module.css';

// Opening section of the guide. Sets expectations: what RepBuddy is, who it is for, and
// what the reader will be able to do by the end of the page. The Help Center search sits in
// the top-right of this section.
//
// `searchRef` is attached to the search row so GuidePage can watch it: once this search
// scrolls under the sticky nav, the nav shows a compact copy in its place.
// `hasHotkey` hands Ctrl/Cmd+K to this instance while it is the visible one.
export default function GuideHero({ searchRef, hasHotkey = true }) {
  return (
    <section className={styles.hero}>
      <div className={styles.topBar} ref={searchRef}>
        <GuideSearch idPrefix="guide-search-hero" hotkey={hasHotkey} />
      </div>
      <div className={styles.inner}>
        <span className={styles.eyebrow}>Help Center</span>
        <h1 className={styles.headline}>Everything RepBuddy does, and how to use it.</h1>
        <p className={styles.sub}>
          RepBuddy turns a plain-English request into a list of real, verified people you can
          sell to. This page walks through every feature, the exact steps to run it, and how
          to get the strongest result from each one. Read it start to finish and you will know
          the whole workflow without anyone walking you through it.
        </p>
      </div>
    </section>
  );
}
